import React from 'react';

const Deals = () => {
    return (
        <div>
            <h1>deals section</h1>
        </div>
    );
};

export default Deals;